import * as tileContentKeys from "../enums/tileContentKeys";
const EMPTY = {
	[tileContentKeys.HIDDEN_SERIES]: {},
};

export default function getEmptyHorizontalBarChartContent() {
	return EMPTY;
}
